import { Box, Pill, Well } from '@bridebook/ui';
import { IFair } from '@bridebook/web/app-shared/lib/supplier/types';
import styles from './fairs-tile.style';
import { getFormattedDate } from '@bridebook/web/lib/utils';

interface IProps {
  fair: IFair;
}

const FairTile = ({ fair }: IProps) => {
  const date = fair.dates[0];
  return (
    <Box style={styles.wrapper}>
      <Well theme="peachRose" size="full">
        <Box style={styles.infoWrap}>
          <Box as="h3" style={styles.fairHeading}>
            {fair.name}
          </Box>
          <Box style={styles.dateWrap}>
            <Pill sidePaddings={6} height={18} color="yellow">
              <Box style={styles.date}>{getFormattedDate({ date })}</Box>
            </Pill>
          </Box>
        </Box>
        <Box style={styles.text}>{fair.description}</Box>
      </Well>
    </Box>
  );
};

export default FairTile;
